import entityMixin from 'src/mixins/miscellaneous/entityMixin.js'
const channelThumbnailMixin = {
  mixins: [entityMixin],
  methods: {
    isConversation (channel) {
      return channel?.type === 'CHAT'
    },

    isPaused (channel) {
      return channel?.meta?.is_paused
    },

    isInactive (channel) {
      if (!channel?.activity_at) return true
      return !this.$moment(channel.activity_at).isValid()
    },

    isDeletedConversation (channel) {
      return this.isConversation(channel) && !channel?.meta?.user_type
    },

    hasShortcut (channel) {
      return ['course-parents', 'courses'].includes(channel?.target)
    },

    channelProps (channel) {
      if (!channel) return
      return this.getEntityData(channel)
    },

    channelPropsIcon (channel) {
      if (!channel) return ''

      // Conversation with deleted user
      if (this.isDeletedConversation(channel)) return 'icon-message-warning-o'

      // Course channels
      if (this.isConversation(channel) || this.hasShortcut(channel)) return ''

      // Entity channels
      return this.channelProps(channel)?.icon
    },

    channelPropsIconText (channel) {
      if (this.isConversation(channel) || this.hasShortcut(channel)) return channel?.meta?.shortcut?.toUpperCase()

      return ''
    },

    channelPropsColor (channel) {
      if (!channel) return

      const additionalClasses = this.isInactive(channel) || this.isDeletedConversation(channel) ? '' : 'text-white'

      if (this.isConversation(channel)) return channel?.meta?.user_type ? `${additionalClasses} type-${channel?.meta?.user_type.toLowerCase()}-bg` : `${additionalClasses} gray-300 secondary-bg`
      return this.isInactive(channel) ? 'gray-300 secondary-bg' : `${this.channelProps(channel)?.color} ${this.channelProps(channel)?.color}-light-bg`
    }
  }
}

export default channelThumbnailMixin
